









import { Component, Vue } from 'vue-property-decorator'
import { Getter } from 'vuex-class'
import { Image } from '@/interfaces/GeneralInterfaces'

@Component({ name: 'MainLogos' })
export default class MainLogos extends Vue {
  @Getter('mainLogo/getLogos')
  items!: Image[]
}
